// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/chunks/792-9a7d9d95a91af0e5.js";
	if (chunkId === 1726) return "static/chunks/1726-99c1a60f549b2adb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1323":"0b013ce234a7d027","2670":"f093f7b10db1738a","7049":"1f25c435b1e30415"}[chunkId] + ".js";
};